<arm-highchart [options]="chartOptions"></arm-highchart>
